module.exports = ReactDnD;


//////////////////
// WEBPACK FOOTER
// external "ReactDnD"
// module id = 4
// module chunks = 0